import React from "react";
import "./Vans.css"
import VabNavbar from "../../components/VanNavBar";
import RetinaImage from "../../components/RetinaImage";
import AutoGallery from "../../components/AutoGallery";

import {Col, Container, Row} from "react-bootstrap";

import main from "../../images/van4/main.jpg";
import main_l from "../../images/van4/main@2x.jpg";
import day_l from "../../images/van4/day@2x.png";
import night_l from "../../images/van4/night@2x.png";
import big from "../../images/van4/big.jpg";
import big_l from "../../images/van4/big@2x.jpg";
import ExpandImage from "../../components/ExpandImage";

const images = [
    '/images/van4/DSC_0295.JPG',
    '/images/van4/DSC_0376.JPG',
    '/images/van4/DSC_0385.JPG',
    '/images/van4/DSC_0311.JPG',
    '/images/van4/DSC_0313.JPG',
    '/images/van4/DSC_0390.JPG',
    '/images/van4/DSC_0391.JPG',
    '/images/van4/DSC_0401.JPG',
    '/images/van4/DSC_0404.JPG',
    '/images/van4/DSC_0407.JPG',
    '/images/van4/DSC_0414.JPG',
    '/images/van4/DSC_0419.JPG',
    '/images/van4/DSC_0422.JPG',
    '/images/van4/DSC_0425.JPG',
    '/images/van4/DSC_0426.JPG',
    '/images/van4/DSC_0427.JPG',
    '/images/van4/DSC_0436.JPG',
    '/images/van4/DSC_0441.JPG',
    '/images/van4/DSC_0450.JPG',
    '/images/van4/DSC_0454.JPG',
];

function Van4() {
    return (
        <div className="vanWrapper">
            <VabNavbar/>
            <div className="vanMain">
                <RetinaImage smallImage={main} largeImage={main_l} altText="WBR GEN 6 GRANDE"/>
            </div>

            <div id="intro" className="vanSection introSection">
                <Container>
                    <div className="vanTitle">WBR GEN 6 GRANDE</div>
                    <div className="vanModel">Generation 6 Toyota HiAce ZX Grande - The Exceptional Off-Grid Campervan</div>
                    <div className="vanSubText">The WBR Gen 6 Grande is a premium fully self-contained campervan, built on the  Generation 6 Toyota HiAce ZX LWB chassis. This model is designed for comfort and safety, making it a great choice for both long road trips and everyday campervan living.
                    </div>
                </Container>
            </div>

            <div id="layout" className="vanSection layoutSection">
                <Container>
                    <div className="vanSectionHeading">CAMPERVAN LAYOUT</div>
                    <div className="vanSubText">WBR Gen 6 Grand is a fully self-contained campervan, perfect for off-grid adventures. Its spacious walkthrough layout ensures easy access, while the removal of the shower unit (Gen 6 Shower) allows for a larger kitchen with ample bench space. Designed for solo travellers or couples, it features flexible sleeping options, a sliding toilet, and generous storage. A 200W solar system and lithium battery with USB ports provide reliable off-grid power. With its modern, space-efficient design, this camper is built for comfort and independence, ready to take you from beaches to mountains in style.
                    </div>
                    <br/>

                    <div className="layoutImages">
                        <Row>
                            <Col lg={6} md={12}>
                                <ExpandImage image={day_l} altText="Gen 6 Shower Day Layout"/>
                            </Col>
                            <Col lg={6} md={12}>
                                <ExpandImage image={night_l} altText="Gen 6 Shower Night Layout"/>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>

            <div className="vanSection videoSection">
                <RetinaImage smallImage={big} largeImage={big_l} altText="Gen 6 Shower Inside View"/>
            </div>

            <div id="specs" className="vanSection specsSection">
                <Container>
                    <div className="vanSectionHeading">SPECIFICATIONS</div>
                    <Row>
                        <Col lg={3} md={6} xs={12}>
                            <ul>
                                <li>Walk through to front seats with rotating front passenger seat</li>
                                <li>Thetford sliding cassette toilet 18L</li>
                                <li>Sink with cold water tap and chopping board</li>
                                <li>Dometic 2 burner LPG hob with glass opening lid</li>
                                <li>Dometic fridge/freezer 80 litre 12v compressor</li>
                                <li>Double 240v power point</li>
                                <li>Redarc 200watt solar panel</li>
                            </ul>
                        </Col>
                        <Col lg={3} md={6} xs={12}>
                            <ul>
                                <li>Redarc 25Amp charging
                                    system, with a DC/DC
                                    Charger and an MPPT solar controller</li>
                                <li>1 x Lithium LiFePo4 Battery with 110Ah</li>
                                <li>Interior walls lined with marine hull-liner</li>
                                <li>Dunlop foam squabs</li>
                                <li>Smoke and Co2 detector </li>
                                <li>240v 30 Amp Victron mains charging system for house battery</li>
                                <li>240v Mains connection with 10-metre power cor</li>
                            </ul>
                        </Col>
                        <Col lg={3} md={6} xs={12}>
                            <ul>
                                <li>Twin USB outlet</li>
                                <li>12v LED lights throughout
                                </li>
                                <li>Dometic roof vent with night blind and fly screen</li>
                                <li>4kg gas bottle</li>
                                <li>Shurflo 12v pressure water pump</li>
                                <li>85 Litre water and 85 Litre
                                    waste tanks mounted under van</li>
                                <li>Tinted windows</li>
                                <li>Thermal backed curtains</li>
                            </ul>
                        </Col>
                        <Col lg={3} md={6} xs={12}>
                            <ul>
                                <li>Includes all certificates, Gas, Electrics, Green Card Self-containment, and Engineering
                                </li>
                                <li>Bed measurements, 2 x 1900mm x 670mm singles or 1400mm x 1770mm sideways double or 1900mm x 1770mm long ways Queen</li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div id="extras" className="vanSection extrasSection">
                <Container>
                    <div className="vanSectionAltHeading">OPTIONAL EXTRAS (AT ADDITIONAL COST)</div>
                    <div className="vanAltSubText">We provide additional features to the standard builds upon request.
                        Some of these include:
                    </div>
                    <Row>
                        <Col lg={4} md={6} xs={12}>
                            <ul>
                                <li>Tow bar square receiver</li>
                                <li>Rear step for square receiver towbar
                                </li>
                                <li>Mud flaps</li>
                                <li>Automatic Satellite Dish NZ SAT Mini</li>
                                <li>RV Media LED Smart TV/DVD 24”</li>
                                <li>Nudge Bar</li>
                                <li>Sliding window  with fly screen -
                                    Rear drivers side</li>
                                <li>Sliding window  with fly screen - Rear passenger side</li>
                                <li>3/4 Squab cut, for sideways sleeping</li>
                                <li>Truma gas/240v water heater 14L</li>
                                <li>Autoterm diesel cabin heater 2kw (Diesel van only)</li>

                            </ul>
                        </Col>
                        <Col lg={4} md={6} xs={12}>
                            <ul>
                                <li>Monsoon weather shield rain protectors x 2</li>
                                <li>Outdoor Shower – cold</li>
                                <li>Internet - Starlink Mini Roam (options available)</li>
                                <li>Passenger overhead cabinet</li>
                                <li>Flyscreen only (for sliding window)</li>
                                <li>Maxxair Deluxe fan/vent power lift with remote</li>
                                <li>Cabin fan 7”</li>
                                <li>240v RCD adapter lead</li>
                                <li>110Amp Battery Upgrade (Lithium) Total 220AH</li>
                                <li>Thetford  Spinflo 2 burner LPG hob with grill</li>
                            </ul>
                        </Col>
                        <Col lg={4} md={6} xs={12}>
                            <ul>
                                <li>Dometic inverter 350watt suitable for laptop</li>
                                <li>Dometic inverter 800watt for ebike charging</li>
                                <li>Dometic inverter 1600watt for airfryer</li>
                                <li>Fiamma 3m awning</li>
                                <li>Extra twin USB outlet</li>
                                <li>Spotlight with USB</li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div id="gallery" className="vanSection gallerySection">
                <Container>
                    <div className="vanSectionBlackHeading">GALLERY</div>
                    <div className="vanBlackSubText">Tap image to enlarge.</div>
                    <AutoGallery images={images}/>
                </Container>
            </div>
        </div>

    )
}

export default Van4;